import { Button } from '@/components/_ui/Button'
import T from '@/components/Helpers/Translate'
import { useModals } from '@/components/ModalManager/useModals'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'

type Props = {
  selectedPurchaseOption: string | null
}

export const HsaFsaEligible = ({ selectedPurchaseOption }: Props) => {
  const {
    app: { marketExceptions },
  } = useGlobalStore()

  const { modals } = useModals()

  const handleOpenHsaFsaDetails = () =>
    modals.openModal({
      type: 'dialogOrDrawer',
      modalId: 'hsa-fsa-details',

      modal: {
        children: (
          <div className="mb-12 space-y-5 p-5 lg:mb-0">
            <Image
              src="/icons/hsa-fsa-eligible.svg"
              height={60}
              width={100}
              alt="HSA/FSA Eligible"
            />
            <h2 className="text-lg font-semibold">
              <T>pay_with_hsa_or_fsa</T>
            </h2>
            <p>
              <T>pay_with_hsa_or_fsa_details</T>
            </p>
          </div>
        ),
      },
    })

  if (!marketExceptions?.hasHsa) return null
  if (!selectedPurchaseOption) return null
  if (selectedPurchaseOption !== 'onetime') return null

  return (
    <div className="flex items-center justify-center space-x-3 px-3">
      <Image
        src="/icons/hsa-fsa-eligible.svg"
        alt="HSA/FSA Eligible"
        width={62}
        height={32}
      />
      <span className="text-sm">
        <T>hsa_fsa_eligible</T>
        <Button
          onClick={handleOpenHsaFsaDetails}
          variant="link"
          className="text-xs underline"
        >
          <T>see_details</T>
        </Button>
      </span>
    </div>
  )
}
